import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

export interface DropdownSelectOption {
  value: any;
  viewValue: string;
}

@Component({
  selector: 'app-dropdown-select',
  templateUrl: './dropdown-select.component.html',
  styleUrls: ['./dropdown-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownSelectComponent implements OnInit {
  @Input() options: DropdownSelectOption[];
  @Input() titleKey = '+GENERAL.DROPDOWN.SELECT_VALUE';
  @Input() defaultValue: DropdownSelectOption;

  selectedValue: DropdownSelectOption;

  @Output() valueSelected = new EventEmitter<DropdownSelectOption>();

  ngOnInit(): void {
    if (this.defaultValue) {
      this.selectedValue = this.options.find((entry) => this.defaultValue.value === entry.value);
    }
  }

  onSelect(): void {
    this.valueSelected.emit(this.selectedValue);
  }
}
